// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Tgx_","productName":"Table_productName__3gWdH"};